import React from 'react';

export interface ICallWindowErrorBoundaryProps {
  children: React.ReactNode;
  fallback: (recover: () => void) => React.ReactNode;
  onError?: (error: Error) => void;
}

interface ICallWindowErrorBoundaryState {
  failed: boolean;
}

class CallWindowErrorBoundary
  extends React.Component<ICallWindowErrorBoundaryProps, ICallWindowErrorBoundaryState> {
  constructor (props: ICallWindowErrorBoundaryProps) {
    super(props);
    this.state = { failed: false };
    this.recover = this.recover.bind(this);
  }

  static getDerivedStateFromError (): ICallWindowErrorBoundaryState {
    return { failed: true };
  }

  componentDidCatch (error: Error): void {
    if (this.props.onError !== undefined) {
      this.props.onError(error);
    }
  }

  recover (): void {
    this.setState({ failed: false });
  }

  render (): React.ReactNode {
    if (this.state.failed) {
      return this.props.fallback(this.recover);
    }
    return this.props.children;
  }
}

export default CallWindowErrorBoundary;
